module.exports = __webpack_public_path__ + "static/media/ManitoAbajo.955cae39.svg";